import React, { useState, useRef, useEffect } from "react";
import {
  Toolbar,
  Stack,
  Fab,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import { styled } from "@mui/material/styles";
import { URL} from '../config'

const Filter = ({setVideos}) => {
  const Genres = ["All", "Education", "Sports", "Comedy", "Lifestyle"];
  const refs = useRef([]);
  const ageRefs = useRef([]);
  const AgeGroups = ["Any", 7, 12, 16, 18];
  const [selectFields, setSelectFields] = useState([
    "Release Date",
    "View Count",
  ]);
  const fabCss = {
    color: "white",
    "background-color": "transparent",
    "box-shadow": "none",
    "&:hover": {
      "background-color": "transparent",
    },
  };
  const [filter, setFilter] = useState({
    genres: [],
    contentRating: "",
    sortBy: "Sort By"
  });

  const handleFilter = () => {
    let obj  = {...filter}
    obj.genres = filter.genres.includes('All') ? 'All' : filter.genres.join(',');

    if(obj.genres.length <= 0)
      delete obj.genres

    if(obj.age_group === '')
      delete obj.contentRating

    if(obj.sortBy === 'Sort By')
      delete obj.sortBy

    const searchParams = new URLSearchParams(obj);
    
    const searchUrl = `${URL}/v1/videos?${searchParams.toString()}`; 
    try {
      fetch(searchUrl)
      .then(res => res.json())
      .then(data => setVideos(data.videos));
    } catch (error) {
      console.log(error);
    }
  }

  const handleSelectChange = (e) => {
    setFilter(prev => ({
      ...prev,
      sortBy: e.target.value
    }));
  };

  const handleGenre = (e, index) => {
    let val = e.target.value;
    let temp = filter.genres;
    let i = temp.indexOf(val);

    if (i >= 0) {
      temp.splice(i, 1);
      let val = Object.entries(fabCss)
        .map(([prop, val]) => `${prop}: ${val};`)
        .join(" ");
      refs.current[index].style = val;
    } else {
      refs.current[index].style = "";
      temp.push(val);
    }
    setFilter((prev) => ({
      ...prev,
      genres: temp,
    }));

  };

  const handleAge = (e, index) => {
    const val = e.target.value;
    let age = filter.contentRating;
    if (age == val) {
      age = "";
      ageRefs.current[index].style = Object.entries(fabCss)
        .map(([prop, val]) => {
          if (prop === "&:hover") {
            return `${prop} {${Object.entries(val)
              .map(([hProp, hVal]) => `${hProp}: ${hVal};`)
              .join(" ")}}`;
          }
          return `${prop}: ${val};`;
        })
        .join(" ");
    } else {
      age = val;
      for (let i = 0; i < ageRefs.current.length; i++) {
        if (index === i) {
          ageRefs.current[index].style = "";
        } else {
          ageRefs.current[i].style = Object.entries(fabCss)
            .map(([prop, val]) => {
              if (prop === "&:hover") {
                return `${prop} {${Object.entries(val)
                  .map(([hProp, hVal]) => `${hProp}: ${hVal};`)
                  .join(" ")}}`;
              }
              return `${prop}: ${val};`;
            })
            .join(" ");
        }
      }
    }

    setFilter((prev) => ({
      ...prev,
      contentRating: age,
    }));

  };

  useEffect(() => {
    handleFilter();
  }, [filter]);

  return (
    <div>
      <Toolbar sx={{ justifyContent: "center", marginBottom: "10px" }}>
        <Stack spacing={2} sx={{ alignItems: "center" }}>
          <Stack spacing={2} direction="row">
            {Genres.map((value, index) => (
              <Fab
                key={`genre-${index}`}
                value={value}
                variant="extended"
                style={fabCss}
                ref={(el) => (refs.current[index] = el)}
                onClick={(e) => handleGenre(e, index)}
              >
                {value}
              </Fab>
            ))}
            <FormControl>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={filter.sortBy}
                startAdornment={
                  <InputAdornment position="start">
                    <SwapVertIcon sx={{ color: "black" }} />
                  </InputAdornment>
                }
                sx={{
                  color: "black",
                  backgroundColor: "#ffffff",
                  border: "none",
                  borderRadius: "24px",
                  minWidth: "178px",
                  height: "48px",
                  "& .MuiInputAdornment-root": {
                    "& .MuiSvgIcon-root": {
                      visibility: "visible",
                    },
                  },
                  "& .MuiSvgIcon-root": {
                    visibility: "hidden",
                  },
                }}
                onChange={handleSelectChange}
              >
                <MenuItem disabled value="Sort By">
                  <em>Sort By</em>
                </MenuItem>
                {selectFields.map((val, i) => (
                  <MenuItem key={`${val}-${i}`} value={val}>
                    {val}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
          <Stack direction="row" spacing={2} className="age_group">
            {AgeGroups.map((value, index) => (
              <Fab
                key={`age-${index}`}
                value={value}
                variant="extended"
                style={fabCss}
                ref={(el) => (ageRefs.current[index] = el)}
                onClick={(e) => handleAge(e, index)}
              >
                {value}
              </Fab>
            ))}
          </Stack>
        </Stack>
      </Toolbar>
    </div>
  );
};

export default Filter;
